// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".draggable-item-list-move[data-v-2fb1486c]{transition:var(--5aa46db2)}", ""]);
// Exports
module.exports = exports;
